import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

import Header from '~/components/Header';
import { ReportBugFloatingButton } from '~/components/ReportBugButton';
import { getAppShellMinHeightStyle } from '~/components/StagingFooter/stagingFooterPadding';
import { aclPermissionsQueryOptions } from '~/features/leadDetails/routes/acceptedOffersQueryOptions';
import { ChatPanel } from '~/features/whatsapp/components/ChatPanel';
import { useApplyUserLanguage } from '~/hooks/useApplyUserLanguage';
import { useWebSocketConnection } from '~/hooks/useWebSocketConnection';
import { useUserStore } from '~/store/userStore';

const AppShell = () => {
    const user = useUserStore.use.user();
    // keep the shared WebSocket open for the authenticated session
    useWebSocketConnection();
    // render the interface in the language the user picked in their settings
    useApplyUserLanguage();
    if (!user) {
        return <Navigate to="/login" />;
    }
    return (
        <div className="flex min-h-screen flex-col" style={getAppShellMinHeightStyle()}>
            <Header />
            <Outlet />
            <ChatPanel />
            <ReportBugFloatingButton />
        </div>
    );
};

export const Route = createFileRoute('/_app')({
    component: AppShell,
    // real ACL before first render — the optimistic loading placeholder would fire gated queries → 403
    loader: async ({ context }) => {
        if (!useUserStore.getState().user) return;
        // failure falls back to the hook's own fetch (fail-closed) instead of blocking the app shell
        await context.queryClient.ensureQueryData(aclPermissionsQueryOptions()).catch(() => undefined);
    },
});
